import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const permission = route.data['permission'] as string | undefined;
  const anyPermission = route.data['anyPermission'] as string[] | undefined;

  if (!permission && !anyPermission) {
    return true;
  }

  const allowed = anyPermission
    ? anyPermission.some((p) => auth.hasPermission(p))
    : auth.hasPermission(permission);

  return allowed || router.parseUrl('/access-denied');
};
